import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="relative flex flex-col items-center justify-center min-h-screen bg-dark text-white px-4 py-16 overflow-hidden">
      {/* Spotlight gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-lighter via-dark to-dark opacity-70"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-dark via-dark-lighter to-dark opacity-50 animate-pulse-slow"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h1 className="relative">
          <span className="text-5xl md:text-6xl lg:text-7xl font-bold mb-2 block">
            <span className="text-gray-300 relative inline-block">
              Minimize Fraud,
            </span>
          </span>
          <span className="text-5xl md:text-6xl lg:text-7xl font-bold block">
            <span className="text-primary relative inline-block drop-shadow-[0_0_25px_rgba(93,209,190,0.3)]">
              Maximize Loyalty
            </span>
          </span>
        </h1>
        
        <p className="text-lg md:text-xl text-gray-300 mt-8 max-w-3xl mx-auto relative">
          AI-driven refund automation paired with actionable post-purchase behavior analysis to ensure refunds are processed faster
        </p>
      </div>
    </section>
  );
};

export default Hero;